import {
  ICreateYapePromotionRequest,
  IEditYapePromotionRequest,
  IEditYapeQrRequest,
  IYapePromotionListParams,
  IYapePromotionReportParams,
  IYapeQrListParams,
} from 'core/model/interfaces/yape/yape.interface';
import { yapeData } from './yape.data';
import {
  mapCreateYapePromotionRequestDomainToDto,
  mapEditYapePromotionRequestDomainToDto,
  mapEditYapeQrRequestDomainToDto,
  mapYapePromotionListDtoToDomain,
  mapYapePromotionListParamsDomainToDto,
  mapYapePromotionReportParamsDomainToDto,
  mapYapePromotionReportResponseDtoToDomain,
  mapYapeQrListDtoToDomain,
  mapYapeQrListParamsDomainToDto,
} from './yape.mapper';

export const yapeService = {
  getYapePromotionList: async (params: IYapePromotionListParams) => {
    const response = await yapeData.getYapePromotionList(mapYapePromotionListParamsDomainToDto(params));
    return mapYapePromotionListDtoToDomain(response);
  },
  createYapePromotion: async (body: ICreateYapePromotionRequest) => {
    await yapeData.createYapePromotion(mapCreateYapePromotionRequestDomainToDto(body));
  },
  editYapePromotion: async (body: IEditYapePromotionRequest) => {
    await yapeData.editYapePromotion(mapEditYapePromotionRequestDomainToDto(body), body.id);
  },
  deleteYapePromotion: async (id: number) => {
    await yapeData.deleteYapePromotion(id);
  },
  getYapePromotionReports: async (body: IYapePromotionReportParams) => {
    const response = await yapeData.getYapePromotionReports(mapYapePromotionReportParamsDomainToDto(body), body.id);
    return mapYapePromotionReportResponseDtoToDomain(response);
  },
  getYapeQrList: async (params: IYapeQrListParams) => {
    const response = await yapeData.getYapeQrList(mapYapeQrListParamsDomainToDto(params), params.id ?? 0);
    return mapYapeQrListDtoToDomain(response);
  },
  editYapeQr: async (body: IEditYapeQrRequest) => {
    await yapeData.editYapeQr(mapEditYapeQrRequestDomainToDto(body), body.yapePromoId ?? 0, body.yapeQrId ?? 0);
  },
};
